import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class RetornaDadosRequest {
	public nivelResponse = null;

	public retornaNivelResponse(status) {
		if (status == 400 || status == 404 || status == 403 || status == 401) {
			return (this.nivelResponse = "Critical");
		} else if (status == 500 || status == 501 || status == 502 || status == 504) {
			return (this.nivelResponse = "Error");
		} else {
			return (this.nivelResponse = "Warning");
		}
	}
}
